const VERSION_PREFIX = '@VERSION/';
export const SET_VERSION = `${VERSION_PREFIX}SET_VERSION`;
export const SET_VERSION_STATUS = `${VERSION_PREFIX}SET_VERSION_STATUS`;
